import { createReducer } from '@reduxjs/toolkit'
import { CfrDefaultParam } from 'interfaces/api/cfrDefaultParams.interfaces'
import { createBuilder } from 'packages/redux-toolkit'

import { getAllCfrDefaultParams, updateCfrDefaultParams } from './actions'

interface CfrDefaultParamsState {
  list: {
    loading: boolean
    items: CfrDefaultParam[]
    loadingUpdate: boolean
  }
}

const initialState: CfrDefaultParamsState = {
  list: {
    loading: false,
    items: [],
    loadingUpdate: false,
  },
}

export const cfrDefaultParamsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllCfrDefaultParams.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllCfrDefaultParams.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllCfrDefaultParams.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })

    .addCase(updateCfrDefaultParams.pending, (state) => {
      state.list.loadingUpdate = true
    })
    .addCase(updateCfrDefaultParams.rejected, (state) => {
      state.list.loadingUpdate = false
    })
    .addCase(updateCfrDefaultParams.fulfilled, (state) => {
      state.list.loadingUpdate = false
    })
})
